const INJECTOR_COMMON_SIZES_CC = [
    80, 100, 120, 160, 190, 210, 225, 250, 280, 315, 345, 380,
    440, 480, 550, 650, 750, 850, 1000, 1200, 1600, 2000, 2200, 2600
];

// Approximate lb/hr -> cc/min conversion at the industry-reference 43.5 psi / 3.0 bar fuel pressure.
const LB_HR_TO_CC_MIN = 10.5;

window.addEventListener("load", () => {
    const hpInput = document.getElementById("injector-hp");
    const cylInput = document.getElementById("injector-cylinders");
    const fuelSelect = document.getElementById("injector-fuel-type");
    const dutySelect = document.getElementById("injector-duty-cycle");

    if (!hpInput || !cylInput || !fuelSelect || !dutySelect) return;

    [hpInput, cylInput].forEach(el => el.addEventListener("input", calculateInjectorSize));
    [fuelSelect, dutySelect].forEach(el => el.addEventListener("change", calculateInjectorSize));

    calculateInjectorSize();
});

function calculateInjectorSize() {
    const hp = parseFloat(document.getElementById("injector-hp").value) || 0;
    const cylinders = parseFloat(document.getElementById("injector-cylinders").value) || 0;
    const bsfc = parseFloat(document.getElementById("injector-fuel-type").value);
    const dutyCycle = parseFloat(document.getElementById("injector-duty-cycle").value);

    const warningEl = document.getElementById("injector-warning-message");
    const lbhrOut = document.getElementById("injector-lbhr-output");
    const ccminOut = document.getElementById("injector-ccmin-output");
    const recommendedEl = document.getElementById("injector-recommended");
    const formulaEl = document.getElementById("injector-formula-display");

    warningEl.innerText = "";
    recommendedEl.innerText = "";
    formulaEl.innerText = "";

    if (hp <= 0 || cylinders <= 0) {
        lbhrOut.innerText = "";
        ccminOut.innerText = "";
        warningEl.innerText = "⚠️ Enter target horsepower and cylinder count.";
        return;
    }

    const lbHr = (hp * bsfc) / (cylinders * dutyCycle);
    const ccMin = lbHr * LB_HR_TO_CC_MIN;

    lbhrOut.innerText = `${lbHr.toFixed(1)} lb/hr`;
    ccminOut.innerText = `${ccMin.toFixed(0)} cc/min`;

    const recommended = INJECTOR_COMMON_SIZES_CC.find(size => size >= ccMin);
    recommendedEl.innerText = recommended
        ? `Recommended off-the-shelf size: ${recommended} cc/min (next size up)`
        : "Required size exceeds common off-the-shelf options — consult a fuel system specialist.";

    formulaEl.innerText = `(${hp} HP × ${bsfc} BSFC) / (${cylinders} injectors × ${dutyCycle} duty cycle) = ${lbHr.toFixed(1)} lb/hr × ${LB_HR_TO_CC_MIN} = ${ccMin.toFixed(0)} cc/min`;
}

function copyInjectorResult() {
    const lbhr = document.getElementById("injector-lbhr-output").innerText;
    const ccmin = document.getElementById("injector-ccmin-output").innerText;
    const recommended = document.getElementById("injector-recommended").innerText;
    const text = [lbhr && `Required: ${lbhr} / ${ccmin}`, recommended].filter(Boolean).join("\n");

    navigator.clipboard
        .writeText(text)
        .then(() => {
            const button = document.querySelector(".injector-calc__copy");
            const originalText = button.innerText;
            button.innerText = "Copied!";
            button.disabled = true;
            setTimeout(() => {
                button.innerText = originalText;
                button.disabled = false;
            }, 1500);
        })
        .catch(() => alert("Failed to copy result"));
}
